import { MobileMenuTypesEnum } from 'common/components/entities/Menu/enums/MobileMenuTypesEnum'

export const mobileMenuTypesLocoKeys: Record<MobileMenuTypesEnum, string> = {
  [MobileMenuTypesEnum.dropDown]: 'entity_settings.menu.mobile_type.drop_down',
  [MobileMenuTypesEnum.side]: 'entity_settings.menu.mobile_type.side',
}
